import React from 'react'
import './BackToStartBtn.css'
import ArrowToStart from '../../Images/arrow-to-start.svg'
import classNames from 'classnames'

const BackToStartBtn = ({ visible = false, ...props }) => {
  let classes = classNames({
    'BackToStartBtn': true,
    'm-fadeIn': visible,
    'm-fadeOut': !visible
  })

  return (
    <div className={classes} {...props}>
      <img src={ArrowToStart} alt='Go back to start' draggable={false} />
    </div>
  )
}

export default BackToStartBtn



// WEBPACK FOOTER //
// ./src/Components/BackToStartBtn/BackToStartBtn.js